import SkeletonCard from '@/app/[locale]/_components/Skeleton/Card'
import { Box, HStack, SimpleGrid, Skeleton, Stack } from '@chakra-ui/react'
import React from 'react'

const Loading = () => {
  return (
    <>
      <Stack gap={2} display={{ base: 'none', lg: 'flex' }}>
        <HStack gap='3'>
          <Skeleton rounded={12} w='42px' h={'42px'} />
          <Stack flex='1'>
            <Skeleton height='5' />
          </Stack>
        </HStack>
        <HStack gap='3'>
          <Skeleton rounded={12} w='42px' h={'42px'} />
          <Stack flex='1'>
            <Skeleton height='5' />
          </Stack>
        </HStack>
      </Stack>
      <Box w={'full'} display={{ base: 'block', lg: 'none' }}>
        <SimpleGrid
          mt={6}
          gap={{ base: 3, lg: 4 }}
          columns={{ base: 2, md: 3, lg: 4 }}
        >
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
          <SkeletonCard />
        </SimpleGrid>
      </Box>
    </>
  )
}

export default Loading
